module.exports = __webpack_public_path__ + "static/media/ui.767a6ff7.svg";